import axios from '../messageApi'

export default {
  /**
   * 获取banner
   */
  getBannerList: data => {
    return axios({
      url: '/protected/publish_banner/list',
      method: 'post',
      data
    })
  },
  /**
   * 获取banner详情
   */
   getBannerDetail: id => {
    return axios({
      url: '/protected/publish_banner/query/' + id,
      method: 'post'
    })
  },
  /**
   * 获取message
   */
  getMessageList: data => {
    return axios({
      url: '/protected/published_message/list',
      method: 'post',
      data
    })
  },
  /**
   * 获取message详情
   */
   getMessageDetail: id => {
    return axios({
      url: '/protected/published_message/query/' + id,
      method: 'post'
    })
  },
  /**
   * 获取跳转banner
   */
   getJumpBannerList: data => {
    return axios({
      url: '/protected/publish_block/list',
      method: 'post',
      data
    })
  },
  /**
   * 下载附件
   */
   downloadFile: uuid => {
    return axios({
      url: '/protected/sas_download_address/' + uuid,
      method: 'post'
    })
  },
  /**
   * 获取资源令牌
   */
   generateToken: () => {
    return axios({
      url: '/protected/file/generate_sas_token',
      method: 'post'
    })
  }
}
